import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LeaveAdjustmentService } from '../leave-adjustment.service';
import * as CurrentLeaveSummaryActions from './current-leave-summary.actions';
import * as fromErrors from '../../shared';
import {
    ResponseStatus,
    IStatusMessage,
    DisplayMessageMinimum
} from '../../shared';
import * as fromShared from '../../shared';
import { catchError, concatMap, flatMap, switchMap } from 'rxjs/operators';

@Injectable()
export class CurrentLeaveSummaryEffects {
    constructor(
        private actions$: Actions,
        private service: LeaveAdjustmentService
    ) {}

    getSummary$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CurrentLeaveSummaryActions.getSummary),
            switchMap(a =>
                this.service.getSummary(a.employeeListID).pipe(
                    flatMap(resp => [
                        CurrentLeaveSummaryActions.upsertCurrentLeaveSummarys({
                            currentLeaveSummarys: resp
                        }),
                        new fromShared.Errors.RemoveErrors(
                            resp
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.EmployeeListID)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putSummary$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrentLeaveSummaryActions.putSummary),
            switchMap(a =>
                this.service.putSummary(a.summary).pipe(
                    flatMap(c => [
                        CurrentLeaveSummaryActions.updateCurrentLeaveSummarys({
                            currentLeaveSummarys: [
                                {
                                    id: a.summary
                                        .map(x => x.EmployeeListID)
                                        .toString(),
                                    changes: c.Items[0]
                                }
                            ]
                        }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.EmployeeListID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.Items
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                            // [
                            //     ...c.ErrorMessages.map(
                            //         x =>
                            //             ({
                            //                 StatusCode: -1,
                            //                 Message: x,
                            //                 MsgProcessID: 0,
                            //                 MsgEntityID: ''
                            //             } as IStatusMessage)
                            //     ),
                            //     ...c.Items.filter(
                            //         x =>
                            //             x &&
                            //             x.Status.StatusCode >=
                            //                 DisplayMessageMinimum
                            //     ).map(x => x.Status)
                            // ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
